import type { Props } from './Svg'
import { Svg } from './Svg'

export function PlusIcon(props: Props) {
  return (
    <Svg width="20" height="20" fill="currentColor" stroke="none" {...props}>
      <path d="M20 9h-9V0H9v9H0v2h9v9h2v-9h9V9Z" />
    </Svg>
  )
}
